/* tslint:disable */
/* eslint-disable */
/**
 * comici-plus-api
 * # Comici Plus API v1  コンテンツプロバイダーがコンテンツの配信サイトを作成するために利用するAPIを提供します。 
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorCodesModel,
  RentalRequestModel,
} from '../models/index';
import {
    ErrorCodesModelFromJSON,
    ErrorCodesModelToJSON,
    RentalRequestModelFromJSON,
    RentalRequestModelToJSON,
} from '../models/index';

export interface PostRentalRequest {
    xComiciUserTokenRequired: string;
    rentalRequestModel: RentalRequestModel;
}

/**
 * 
 */
export class PaymentApi extends runtime.BaseAPI {

    /**
     * レンタル処理を実行します。(対象エピソードは無料/有料を含みます。) レンタル方法としては単話レンタル, まとめてレンタルに対応します。 完全無料および会員のみ無料(今なら無料)には対応していないため、実行しないでください (内部的に待つと無料扱いとなります) [リクエストパターン]    単話レンタル     待つと無料エピソード : articleHashKeys (1件のみ) を指定, amount, ticketCount は0またはリクエストに含めないでください     有料エピソード : articleHashKeys (1件のみ), amount, ticketCount を指定してください   まとめてレンタル : articleHashKeys (複数件), seriesHashKey, amount, ticketCount を指定してください
     * レンタル
     */
    async postRentalRaw(requestParameters: PostRentalRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.xComiciUserTokenRequired === null || requestParameters.xComiciUserTokenRequired === undefined) {
            throw new runtime.RequiredError('xComiciUserTokenRequired','Required parameter requestParameters.xComiciUserTokenRequired was null or undefined when calling postRental.');
        }

        if (requestParameters.rentalRequestModel === null || requestParameters.rentalRequestModel === undefined) {
            throw new runtime.RequiredError('rentalRequestModel','Required parameter requestParameters.rentalRequestModel was null or undefined when calling postRental.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xComiciUserTokenRequired !== undefined && requestParameters.xComiciUserTokenRequired !== null) {
            headerParameters['X-Comici-User-Token-Required'] = String(requestParameters.xComiciUserTokenRequired);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("contentApiKey", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/payment/rental`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RentalRequestModelToJSON(requestParameters.rentalRequestModel),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * レンタル処理を実行します。(対象エピソードは無料/有料を含みます。) レンタル方法としては単話レンタル, まとめてレンタルに対応します。 完全無料および会員のみ無料(今なら無料)には対応していないため、実行しないでください (内部的に待つと無料扱いとなります) [リクエストパターン]    単話レンタル     待つと無料エピソード : articleHashKeys (1件のみ) を指定, amount, ticketCount は0またはリクエストに含めないでください     有料エピソード : articleHashKeys (1件のみ), amount, ticketCount を指定してください   まとめてレンタル : articleHashKeys (複数件), seriesHashKey, amount, ticketCount を指定してください
     * レンタル
     */
    async postRental(requestParameters: PostRentalRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postRentalRaw(requestParameters, initOverrides);
    }

}
